module.exports = __webpack_public_path__ + "img/usa.166db72a.svg";